import Popup from '../../common/popup/Popup';
import Modules from '../../gui/modules/Modules';
import HardCurrency from './hardCurrency/HardCurrency';
import StarterPack from './starterPack/StarterPack';

const HEIGHT = 970;

export default class Shop extends Popup {
    private starterPack!: StarterPack;
    private hardCurrency!: HardCurrency;

    constructor(scene: Phaser.Scene) {
        const TITLE_KEY = 'SHOP';
        super(scene, TITLE_KEY, HEIGHT);

        // this.setupStarterPack();
        this.setupHardCurrency();
        this.setupListeners();
    }

    private setupStarterPack(): void {
        const x = 0;
        const y = 14;

        this.starterPack = new StarterPack(this.scene, x, y);
        this.contentContainer.add(this.starterPack);
    }

    private setupHardCurrency(): void {
        const x = 0;
        const y = 15//170;

        this.hardCurrency = new HardCurrency(this.scene, x, y);
        this.contentContainer.add(this.hardCurrency);
    }

    private setupListeners(): void {
        this.scene.events.on(Modules.EVENTS.SHOW_SHOP, this.show, this);
    }

    destroy(fromScene?: boolean): void {
        this.scene.events.off(Modules.EVENTS.SHOW_SHOP, this.show, this);
        super.destroy(fromScene);
    }
}
